export default __webpack_public_path__ + "static/media/BucklingImg.d26058ac.jpg";